import { ThunkAction } from "redux-thunk";
import {
  SubContactItem,
  SubContactItemType,
} from "common/models/SubContactItem";
import { GlobalState } from "store/configure-store";
import {
  SUB_CONTACT_CREATED,
  SUB_CONTACT_CREATED_ERROR,
  SUB_CONTACT_CURRENT,
  SUB_CONTACT_START,
  SubContactAction,
} from "store/types/sub-contact.types";
import * as SubContactAPI from "api/sub-contact.api";
import { Dispatch } from "react";
import { selectCurrentSubContact } from "store/reducers/patient.reducer";

/** ---- ACTIONS ---- */
export const createSubContactIfNeeded = (
  patientId: number,
  caregiverId: number,
  contactId: number
): ThunkAction<Promise<SubContactItem>, GlobalState, any, SubContactAction> => {
  return async (dispatch, getState) => {
    try {
      dispatchSubContactStart()(dispatch);
      const subContactItem = selectCurrentSubContact(getState());
      if (subContactItem.id >= 0 && subContactItem.contactID === contactId) {
        dispatchUseCurrentSubContact(subContactItem)(dispatch);
        return Promise.resolve(subContactItem);
      }
      const subContact = await SubContactAPI.createEmptySubContact(
        patientId,
        caregiverId,
        contactId
      );
      dispatchSubContactCreated(subContact)(dispatch);
      return Promise.resolve(subContact);
    } catch (e) {
      dispatchSubContactCreatedError()(dispatch);
      throw e;
    }
  };
};

/** ---- DISPATCHERS ---- */
const dispatchSubContactStart = () => {
  return (dispatch: Dispatch<SubContactAction>) => {
    dispatch({ type: SUB_CONTACT_START });
  };
};

const dispatchUseCurrentSubContact = (subContact: SubContactItemType) => {
  return (dispatch: Dispatch<SubContactAction>) => {
    dispatch({ type: SUB_CONTACT_CURRENT, payload: subContact });
  };
};

const dispatchSubContactCreated = (subContact: SubContactItem) => {
  return (dispatch: Dispatch<SubContactAction>) => {
    dispatch({ type: SUB_CONTACT_CREATED, payload: subContact });
  };
};

const dispatchSubContactCreatedError = () => {
  return (dispatch: Dispatch<SubContactAction>) => {
    dispatch({ type: SUB_CONTACT_CREATED_ERROR });
  };
};
